import { FC, MouseEvent, useEffect, useRef } from "react";

interface IProps {
  checked: boolean;
  indeterminate?: boolean;
  disabled?: boolean;
  "aria-label": string;
  //* `shiftKey` permet la sélection d'une plage de lignes
  onToggle: (shiftKey: boolean) => void;
}

const RowSelectionCheckbox: FC<IProps> = ({
  checked,
  indeterminate = false,
  disabled = false,
  onToggle,
  ...props
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  //* Un clic sur le label relance un clic sur l'input : on garde Maj de côté
  const shiftKeyRef = useRef(false);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate && !checked;
    }
  }, [indeterminate, checked]);

  const handleMouseDown = (e: MouseEvent<HTMLLabelElement>) => {
    shiftKeyRef.current = e.shiftKey;
    //* Évite que Maj+clic surligne le texte entre deux lignes
    if (e.shiftKey) e.preventDefault();
  };

  return (
    <label
      className="formalys-select-hit"
      onMouseDown={handleMouseDown}
      data-disabled={disabled || undefined}
    >
      <input
        ref={inputRef}
        type="checkbox"
        className="form-check-input formalys-select-checkbox"
        checked={checked}
        disabled={disabled}
        aria-label={props["aria-label"]}
        onChange={(e) => {
          const shiftKey =
            (e.nativeEvent as unknown as globalThis.MouseEvent).shiftKey ||
            shiftKeyRef.current;
          shiftKeyRef.current = false;
          onToggle(shiftKey);
        }}
      />
    </label>
  );
};

export default RowSelectionCheckbox;
